import { useQuery } from "@tanstack/react-query";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { getListaHealthScore } from "./api";

// Porte de app/controllers/lista-health-score.controller.js +
// app/templates/instituicao/lista-health-score.html. Tela mais simples do
// app: uma única chamada GET sem paginação (não usa o contrato
// Filtrar/Paginado, então não passa por usePagedQuery), ordenada
// client-side por healthScore desc — reproduz o `orderBy:'-healthScore'`
// do template legado.
export default function HealthScore() {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["health-score"],
    queryFn: getListaHealthScore,
  });

  const rows = [...(data ?? [])].sort((a, b) => b.healthScore - a.healthScore);

  return (
    <div className="space-y-4">
      <h1 className="text-lg font-semibold text-foreground">Health Score</h1>

      {isLoading && <Skeleton className="h-64 w-full" />}

      {isError && (
        <Alert variant="destructive">
          <AlertTitle>Erro ao carregar</AlertTitle>
          <AlertDescription className="flex items-center justify-between gap-4">
            Não foi possível carregar a lista de health score.
            <Button size="sm" variant="outline" onClick={() => refetch()}>
              Tentar novamente
            </Button>
          </AlertDescription>
        </Alert>
      )}

      {!isLoading && !isError && (
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>ID</TableHead>
              <TableHead>Código</TableHead>
              <TableHead>Nome</TableHead>
              <TableHead>Health Score</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} className="text-center text-muted-foreground">
                  Nenhuma instituição encontrada.
                </TableCell>
              </TableRow>
            ) : (
              rows.map((r) => (
                <TableRow key={r.id}>
                  <TableCell>{r.id}</TableCell>
                  <TableCell>{r.codigo}</TableCell>
                  <TableCell>{r.nome}</TableCell>
                  <TableCell>{r.healthScore}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      )}
    </div>
  );
}
